export default {
  'draft': {
    id: 0,
    ru: 'Черновик',
    en: 'Draft'
  }
}
